import { Network } from '@capacitor/network';

let isConnected = true;

export const InitNetworkStatus = async () => {
  const status = await Network.getStatus();
  isConnected = status.connected;
};

// Private helper
const listeners = new Set();

const notifyListeners = () => {
  for (const fn of listeners) fn(isConnected);
};

// Capacitor listener
Network.addListener('networkStatusChange', (status) => {
  isConnected = status.connected;
  notifyListeners();
});

// Public getter
export const isOnline = () => isConnected;

// Subscribe function for React
export const subscribeToNetwork = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};
